import { IconProps } from '@opendoor/bricks/core';

/** Leave constant for future revisions */
export const SHOW_REV_3 = null;

type Accomplishment =
  | { iconName: IconProps['name']; text: string }
  | { image: string; text: string };
export type Agent = {
  name: string;
  description: string;
  image: string;
  accomplishments: Accomplishment[];
};
/** Hardcoded info about our 2 charlotte listing agents */
export const CHARLOTTE_AGENTS: Agent[] = [
  {
    name: 'Wesley Nguyen',
    description: 'Local agent • Charlotte region',
    image: 'https://imgdrop.imgix.net/41bf34d621ee499086d5155beca651e1.png',
    accomplishments: [
      {
        image: 'https://imgdrop.imgix.net/a34340e8546f439c87de3b130f43f16b.png',
        text: 'Top Opendoor agent',
      },
      {
        iconName: 'home-cost',
        text: '$367K average sale price',
      },
    ],
  },
  {
    name: 'Kevin Bell',
    description: 'Local agent • Charlotte region',
    image: 'https://imgdrop.imgix.net/2023-03-1679519599639-40097.png',
    accomplishments: [
      {
        iconName: 'expertise',
        text: 'Trusted partner agent',
      },
      {
        iconName: 'home-cost',
        text: '$374K average sale price',
      },
    ],
  },
];

/** Some information about our JAX partner agents  */
export const JACKSONVILLE_AGENTS: Agent[] = [
  {
    name: 'Taquilla Allen',
    description: 'Local agent • Jacksonville region',
    image: 'https://imgdrop.imgix.net/2023-04-1682568787921-82911.png',
    accomplishments: [
      {
        iconName: 'expertise',
        text: 'Trusted partner agent',
      },
      {
        iconName: 'home-cost',
        text: '$400K average sale price',
      },
    ],
  },
  {
    name: 'Gabriel Butler',
    description: 'Local agent • Jacksonville region',
    image: 'https://imgdrop.imgix.net/2023-04-1682568776741-46467.png',
    accomplishments: [
      {
        iconName: 'expertise',
        text: 'Trusted partner agent',
      },
      {
        iconName: 'home-cost',
        text: '$450K average sale price',
      },
    ],
  },
];

/**
 * Export this constant and use the market to grab the correct agent set to show on the dashboard
 * If you need to add a new market, add it to this object and add the corresponding agent set above
 * note that the markets come from the backend in all caps
 */
export const AGENTS: { [key: string]: Agent[] } = {
  CHARLOTTE: CHARLOTTE_AGENTS,
  JACKSONVILLE: JACKSONVILLE_AGENTS,
};

/** Part of the repeat experience */
export const HAS_SEEN_REFRESH_MODAL = 'opendoor.selling.hasSeenRefreshModal';

/** Local storage name for lwc unenrollment modal key */
export const HAS_SEEN_UNENROLLMENT_MODAL = 'opendoor.selling.hasSeenLWCUnenrollmentModal';

export const LWC_MODAL_STYLES = {
  desktopMaxWidth: '690px',
  desktopContentMaxWidth: '327px',
};

export const LWC_BUTTON_STYLES = {
  mobileMinHeight: '40px',
  desktopMinHeight: '56px',
};
